import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLockOpen,
  faIdCard,
  faUsers,
  faPeopleGroup,
  faHeart,
  faProjectDiagram,
  faCogs,
  faMapMarkerAlt,
  faCalendarAlt,
  faListAlt,
  faUser,
  faKey,
  faCog,
  faTachometerAlt,
  faFileUpload,
  faImages,
  faStream,
  faTasks
} from '@fortawesome/free-solid-svg-icons';
import './MyProfileHome.css';

function MyProfileHome() {
  return (
    <div>
      <div className="min-h-[90vh] py-8 bg-black">
        <div className='border-b border-blue-400 py-2'>
          <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-left mb-2'>
            <FontAwesomeIcon icon={faUser} />
            <span className='px-4'>Think5Whys My Profile / Account</span>
          </h2>
        </div>
        <div className="mx-auto px-4 text-sm mt-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-2 py-2 px-2">
            <CardLink to="/myprofile-profile" icon={faUser} text="My Profile" />
            <CardLink to="/myprofile-think5whyscode" icon={faLockOpen} text="My Think5Whys Code" />
            <CardLink to="/myprofile-blueprofile" icon={faUser} text="My Blue Profile" />
            {/* <CardLink to="/myprofile-intern" icon={faUser} text="My Internship Profile" /> */}
            <CardLink to="/myprofile-feellikeapp" icon={faCog} text="Feel Like App Setting" />
            <CardLink to="/contact-genious-home" icon={faIdCard} text="My Digital Card" />
            <CardLink to="/myprofile-ownteams" icon={faUsers} text="My Groups / Team" />
            <CardLink to="/myprofile-joinedteams" icon={faPeopleGroup} text="Groups / Team I have Joined" />
            <CardLink to="/myprofile-projects" icon={faTasks} text="My Projects" />
            <CardLink to="/myprofile-processes" icon={faStream} text="My Processes" />
            <CardLink to="/myprofile-locations" icon={faMapMarkerAlt} text="My Locations / Machines" />
            <CardLink to="/myprofile-changepassword" icon={faKey} text="Change Password" />
            <CardLink to="/myprofile-resetpassword-questions" icon={faKey} text="Reset Password Hint Questions" />
            <CardLink to="/myprofile-ikigai" icon={faHeart} text="IKIGAI" />
            {/* <CardNoLink to="" icon={faHeart} text="IKIGAI" /> */}
            <CardLink to="/myprofile-myorders" icon={faLockOpen} text="My Orders" />
             {/* <CardNoLink to="" icon={faLockOpen} text="My Orders" /> */}
            <CardLink to="/myprofile-lifestages" icon={faCalendarAlt} text="My Life Stage / Life Chunk" />
            {/* <CardNoLink to="" icon={faCalendarAlt} text="My Life Stage / Life Chunk" /> */}
            <CardLink to="/myprofile-checklist" icon={faListAlt} text="My Checklists" />
            {/* <CardNoLink to="" icon={faListAlt} text="My Checklists" /> */}
            <CardLink to="/myprofile-configure-mydashboard" icon={faTachometerAlt} text="Configure Own Dashboard" />
            {/* <CardNoLink to="" icon={faTachometerAlt} text="Configure Own Dashboard" /> */}
            <CardLink to="/myprofile-myfiles" icon={faFileUpload} text="My File Uploader" />
            <CardNoLink to="" icon={faFileUpload} text="My File Uploader" />
          </div>
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm lg:text-lg text-yellow-200">
            (c) 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-[#005C5C]">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-[#005C5C]">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-[#005C5C]">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-[#005C5C]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-teal-300 p-2 rounded-lg shadow-lg">
    <Link to={to} className="flex items-center text-sm sm:text-m text-black hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-500 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-white hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default MyProfileHome;
